import React, {useEffect} from 'react';
import BreadcrumbsBar from "../../layouts/breadcrumb/BreadcrumbsBar";
import {getAllCampaigns, getGeneratedLinkFromAPI} from "../../services/mlinkService";
import GenericTable from "../../common/table/GenericTable";
import {Button, TextField} from "@mui/material";
import styles from "./MLinkIntegration.module.scss";
import useModal from "../../common/hooks/useModal";
import Modal from "../../common/modal/Modal";
import Card from "../../common/card/Card";

const MLinkIntegration = () => {

    const [campaigns, setCampaigns] = React.useState([]);
    const [selectedInfId, setSelectedInfId] = React.useState(null);
    const {isModalOpen, toggleModal, modalContent, setModalContent} = useModal();
    const productColumns = {};
    productColumns.visibility = {}
    productColumns.data = [
        {
            accessorKey: 'name',
            header: "Product Name",
        }, {
            accessorKey: 'image',
            header: "Product Name",
            Cell: (cell) => (<img src={cell.row.original.image} alt={cell.row.original.name} width={100}/>)
        }
    ];

    const campaignColumns = {};
    campaignColumns.visibility = {};
    campaignColumns.data = [
        {
            accessorKey: 'Actions',
            header: "Actions",
            Cell: (cell) => (
                <div className={styles.generateLinkContainer}>
                    <TextField
                        id="outlined-basic"
                        name="titleEn"
                        label={"Influencer ID"}
                        value={selectedInfId}
                        variant="outlined"
                        onChange={handleInputChange}
                    />
                    <Button variant="contained" color="primary" size="small" onClick={(e) => {
                        generateCampaignLink(cell.row.original.id);
                    }
                    }>Generate Link</Button>
                </div>
            )
        },
        {
            accessorKey: 'id',
            header: "Campaign ID",
        }, {
            accessorKey: 'name',
            header: "Campaign Name",
        }, {
            accessorKey: 'brandCampaignCommissionRate',
            header: "Brand Commission Rate",
            Cell: (cell) => (<div>%{cell.row.original.brandCampaignCommissionRate}</div>)
        }, {
            accessorKey: 'influencerCommissionRate',
            header: "Influencer Commission Rate",
            Cell: (cell) => (<div>%{cell.row.original.influencerCommissionRate}</div>)
        }, {
            accessorKey: 'otherCostsRate',
            header: "Other Costs Rate",
            Cell: (cell) => (<div>%{cell.row.original.otherCostsRate}</div>)
        }, {
            accessorKey: 'endDate',
            header: "End Date",
            Cell: (cell) => (<div> {cell.row.original.endDate}</div>)
        },
    ];


    const handleInputChange = (e) => {
        const {value} = e.target;
        setSelectedInfId(value);
    }

    const getCampaigns = async () => {
        const response = await getAllCampaigns()
        if (response.status === 200) {
            setCampaigns(response.data);
        } else {
            console.error("Failed to fetch campaigns");
        }
    }


    const getGeneratedLink = async (campaignId) => {
        const payload = {
            "influencerID": selectedInfId,
            "influencerName": selectedInfId,
            "campaignID": campaignId
        }
        const response = await getGeneratedLinkFromAPI(payload);

        const urlData = response.data;
        if (!!urlData && !!urlData.url) {
            setModalContent({
                title: "Generated Link",
                content: <div>
                    <p>Generated Link: {urlData.url}</p>
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={(e) => {
                            navigator.clipboard.writeText(urlData.url);
                        }
                        }>Copy Link</Button>
                    <p>Campaign Name: {urlData.name}</p>
                    <p>End Date: {urlData.endDate}</p>
                </div>
            })
        } else {
            setModalContent({
                title: "Error",
                content: <div>
                    <p>{urlData.message}</p>
                </div>
            })
        }
        toggleModal();

    }


    const generateCampaignLink = async (campaignID) => {

        await getGeneratedLink(campaignID);
    }

    const expandProducts = (cell) => {
        console.log(cell);
        return (
            <GenericTable
                outputColumns={productColumns}
                tableData={cell.row.original.products}
                rowCount={cell.row.original.products.length}
                tableExpandPadding={0}
                headerBgColor={"#E74C3C"}
            ></GenericTable>
        )
    }

    useEffect(() => {
        getCampaigns().then(response => console.log(response));
    }, []);

    return (<div>
        <BreadcrumbsBar/>
        <Card title="Mlink Campaigns">
            <div className="container">
                {/* Add your integration logic and components here */}
                {campaigns && campaigns.length > 0 && <GenericTable
                    outputColumns={campaignColumns}
                    tableData={campaigns}
                    rowCount={campaigns.length}
                    expand={expandProducts}

                    tableExpandPadding={0}
                    enablePagination={true}
                />}
            </div>
        </Card>
        <Modal
            isOpen={isModalOpen}
            title={modalContent.title}
            content={modalContent.content}
            onCancelation={toggleModal}
        />
    </div>);
};

export default MLinkIntegration;
